import { useLocation } from "react-router-dom";

import { Box, Typography, TypographyProps } from "@mui/material";
import styled from "@mui/material/styles/styled";

import EmptyTabImg from "@app/analytics/assets/empty_tab.png";
import useAuth from "@app/common/auth/useAuth";
import LINKS from "@app/common/links";
import { withQueryParams } from "@app/common/utils";

import Button from "@rui/Button";
import { EmptyStateOuterContainer } from "@rui/EmptyStateContainer";
import Link from "@rui/Link";
import Stack, { Column, StackProps } from "@rui/Stack";

const ContentContainer = styled((props: StackProps) => (
  <Column variant="center" spacing={1} {...props} />
))({ maxWidth: "600px" });

const Title = styled(Typography)(({ theme }) => ({
  fontSize: "1.25rem",
  color: theme.palette.shades.neutral[800],
  fontWeight: 500,
}));

const Description = styled((props: TypographyProps) => (
  <Typography variant="bodySecondaryReg" {...props} />
))(({ theme }) => ({
  color: theme.palette.shades.neutral[600],
}));

const Action = styled(Button)({
  minWidth: "160px",
  maxWidth: "100%",
});

const EmptyTab = ({
  canUpgradeCurrentReport,
  tab,
  title,
}: {
  canUpgradeCurrentReport: boolean;
  tab: string;
  title: string;
}) => {
  const { user } = useAuth();
  const location = useLocation();

  return (
    <Stack flex={1} padding={2}>
      <EmptyStateOuterContainer>
        <ContentContainer spacing={3}>
          <Stack variant="center" spacing={1}>
            <Box
              component="img"
              src={EmptyTabImg}
              alt={title}
              sx={{ width: "150px" }}
            />
            <Title>{title}</Title>
            <Description>
              {user
                ? `You're out of free reports for the month, ${user.firstName}. `
                : ""}
              Upgrade to Read Pro or Enterprise to view the {tab} report for{" "}
              {canUpgradeCurrentReport ? "this" : "your next"} meeting.
            </Description>
          </Stack>
          <Stack spacing={1}>
            <Link
              to={withQueryParams(
                location.pathname,
                { popup: "upgrade" },
                location.search
              )}
            >
              <Action>Upgrade</Action>
            </Link>
            <Link href={LINKS.MARKETING.PLANS_PRICING}>
              <Action variant="text">Compare plans</Action>
            </Link>
          </Stack>
        </ContentContainer>
      </EmptyStateOuterContainer>
    </Stack>
  );
};

export default EmptyTab;
